<template>
  <roe-error-message :field="design.profit_sharing_basic_require_last_day">
    <roe-radio-input
      v-model="design.$model.profit_sharing_basic_require_last_day"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerOtherEOYRequirementRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
